import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useFocusedField } from './focused-field-provider';
const EventsContext = /*#__PURE__*/createContext(undefined);
export const EventsProvider = _ref => {
  let {
    children
  } = _ref;
  const [submitSuccessCounter, setSubmitSuccessCounter] = useState(0);
  const [submittedValues, setSubmittedValues] = useState({});
  const value = useMemo(() => ({
    submitSuccessCounter,
    submittedValues,
    fireSubmitSuccess: values => {
      setSubmitSuccessCounter(previous => previous + 1);
      setSubmittedValues(values || {});
    }
  }), [submitSuccessCounter, submittedValues]);
  return /*#__PURE__*/React.createElement(EventsContext.Provider, {
    value: value
  }, children);
};
const useEvents = () => {
  const context = useContext(EventsContext);
  if (context === undefined) {
    throw new Error('useEvents must be used within a EventsProvider');
  }
  return context;
};
export const useSubmitSuccessTrigger = () => {
  const {
    fireSubmitSuccess
  } = useEvents();
  return fireSubmitSuccess;
};
export const useSubmitSuccessEvent = onSubmitSuccess => {
  const {
    submitSuccessCounter,
    submittedValues = {}
  } = useEvents();
  const previousCounter = useRef(submitSuccessCounter);
  useEffect(() => {
    if (previousCounter.current !== submitSuccessCounter) {
      previousCounter.current = submitSuccessCounter;
      onSubmitSuccess(submittedValues);
    }
  }, [submitSuccessCounter, onSubmitSuccess, submittedValues]);
};
export const useFocusGroupFieldEvent = (groupFieldId, getFocusedChildFieldId) => {
  const {
    focusedFieldId,
    setFocusedFieldId
  } = useFocusedField();
  useEffect(() => {
    if (groupFieldId && focusedFieldId === groupFieldId) {
      const fieldId = getFocusedChildFieldId();
      if (fieldId) {
        setFocusedFieldId(fieldId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupFieldId, focusedFieldId, setFocusedFieldId]);
};
export const useFocusFieldEvent = (onFocusField, fieldId) => {
  const {
    focusedFieldId,
    setFocusedFieldId
  } = useFocusedField();
  useEffect(() => {
    if (fieldId && focusedFieldId && focusedFieldId === fieldId) {
      onFocusField();
      setFocusedFieldId(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldId, focusedFieldId, setFocusedFieldId]);
};
//# sourceMappingURL=events-context.js.map